<template>
  <div>
    <div class="title">
      <span class="i"></span>已执行未结款
      (
      <div style="display: inline-block" v-if="searchCondition.time_type!=='all'">
        <span v-if="searchCondition.year">{{ searchCondition.year }}年</span>
        <span v-if="searchCondition.month">{{ searchCondition.month }}月</span>
        <el-tooltip class="item" effect="dark" content="以“下单时间”为维度" placement="top-start">
          <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
        </el-tooltip>
      </div>
      <div style="display: inline-block" v-else>
        全部
      </div>
      )
    </div>
    <el-form :model="searchCondition" label-width="70px" class="forms" size="mini" inline>
      <el-form-item label="客户名称">
        <el-input
            class="el-input-m"
            v-model="searchCondition.name"
            placeholder="请输入客户名称"
            @change="search" clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
            type="primary"
            @click="initList()"
            icon="el-icon-search"
        >查询
        </el-button>
        <el-button type="text" @click="reset" style="margin-left:30px;">重置
        </el-button>
      </el-form-item>
    </el-form>
    <div class="default-table" style="width: 100%">
      <ape-table
          :ref="tableRef"
          :data="dataList"
          :paging-data="pagingData"
          :columns="[]"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          @changeTableSort="changeTableSort"
          show-summary
          highlight-current-row
          style="width: 100%"
          max-height="600px"
      >
        <el-table-column label="序号" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公司（客户）名称" prop="name" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.customer ? scope.row.customer.name : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售" prop="sale_name" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sale ? scope.row.sale.name : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单总金额" prop="payment_account" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.payment_account,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已回款金额" prop="sum_amount" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.sum_amount,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="需回款金额" prop="remain_account" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.remain_account,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            key="操作项"
            label="操作项"
            align="center"
            :min-width="80"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="exOrderDetail(scope.row.id)">查看详情</el-link>
          </template>
        </el-table-column>
      </ape-table>
    </div>

  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {getNonPayData} from "@/api/home";

export default {
  name: "ExecUnsettledOrderTable",
  components: {ApeTable},
  props: {
    year: [Number, String],
    month: [Number, String],
    timeType: {
      type: String,
      default() {
        return 'not_all'
      }
    },
  },
  data() {
    return {
      loadingStatus: false,
      dataList: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 8
      },
      orderSortObj: {},//默认排序规则
      searchCondition: {
        year: null,
        month: null,
        name: null,
        time_type: 'not_all',
        start_time: 0,
        end_time: 0,
        bool_exec: 1
      },
      tableRef: 'refSaleExecUnsettledSummaryTable',
    }
  },
  watch: {
    timeType() {
      this.searchCondition.time_type = this.timeType
      this.search()
    },
    year() {
      this.searchCondition.year = this.year
      this.search()
    },
    month() {
      this.searchCondition.month = this.month
      this.search()
    }
  },
  created() {
    this.searchCondition.year = this.year
    this.searchCondition.month = this.month
    this.searchCondition.time_type = this.timeType
    this.search()
  },
  methods: {
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '合计:'
          return
        }
        if (['order_count', 'sum_money'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          switch (column.property) {
            case 'order_count':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            case 'sum_money':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            default:
              break
          }
        }
      })

      return sums
    },
    changeTableSort({prop, order}) {
      this.orderSortObj = {order: order, prop: prop}
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      //
      // this.orderSort = orderSort
      this.initList()
    },
    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    //加载表格数据
    initList(type) {
      // let month = {}
      let searchCondition = this.handleSearchCondition()
      let pagingInfo = this.$refs[this.tableRef].getPagingInfo(type)

      Object.assign(searchCondition, {
        page: pagingInfo.current_page,
        per_page: pagingInfo.page_size
      }, this.orderSortObj)

      this.loadingStatus = true

      getNonPayData(searchCondition).then(res => {
        this.loadingStatus = false
        this.dataList = res.model.data || [];
        this.pagingData.total = res.model.total || 0
      })
    },
    search() {
      if (this.$refs[this.tableRef])
        this.$refs[this.tableRef].handleCurrentChange(1)
    },
    reset() {
      this.searchCondition.name = "";
      this.search()
    },

    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_type) {
        condition.time_type = this.searchCondition.time_type
      }

      if (this.searchCondition.bool_exec) {
        condition.bool_exec = this.searchCondition.bool_exec
      }

      if (this.searchCondition.year) {
        let year = this.searchCondition.year
        let month = this.searchCondition.month
        if (month) {
          month = parseInt(month)
          let day = new Date(parseInt(year), month, 0);
          let daycount = day.getDate();//最后一天
          condition.start_time = year + '-' + (month > 9 ? month : '0' + month) + '-01'
          condition.end_time = year + '-' + (month > 9 ? month : '0' + month) + '-' + daycount
        } else {
          condition.start_time = year + '-01-01'
          condition.end_time = year + '-12-31'
        }

        //时间转成时间戳
        condition.start_time = (new Date(condition.start_time).getTime()) / 1000
        condition.end_time = (new Date(condition.end_time).getTime()) / 1000
      }

      return condition
    },
    //查看详情
    exOrderDetail(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style scoped>
.title .i {
  background: #e03f3d;
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
}

.forms {
  margin-top: 20px;
}

.el-input-m {
  width: 80%;
}
</style>